import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Column, Icon, Loading, Select, Table } from '@tencent/spaui';
import Cookies from 'js-cookie';
import { RPCFactory } from '../../../utils/RequestUtil';
import RuleDialog from './MessageSendingRuleDialog';

import ABulkMiniDialog from '../businessSetting/ABulkMiniDialog';

import useDialog from '../../../leads_component/shared-components/hooks/useDialog';
import useTable from '../../../leads_component/shared-components/hooks/useAsyncTable';
import useConfirm from '../../../leads_component/shared-components/hooks/useContentDialog';
import useSelect from '../../../leads_component/shared-components/hooks/useSelect';

import useApp from '../../hooks/useApp';

import { badgePrefix as prefix } from '../../../consts/prefix';

const WechatMessageTypeEnum = {
  TEXT: { value: 'TEXT', desc: '文本', key: 'text' },
  IMAGE: { value: 'IMAGE', desc: '图片', key: 'image' },
  IMAGE_TEXT: { value: 'IMAGE_TEXT', desc: '图文', key: 'imageText' },
};

const MessageManagementPage = (props) => {
  const dialogHooks = useDialog({ showDialog: false });
  const { currentApp, setApp } = useApp({ uid: window.pageProps.uid });
  const wxAppHooks = useSelect({ data: [], value: currentApp });
  const [tagList, setTagList] = useState([]);
  // const [reload, setReload] = useState(0);

  const [target, setTarget] = useState(null);
  const deleteConfirmHooks = useConfirm({ showDialog: false });

  const [operating, setOperating] = useState(false);

  useEffect(() => {
    if (wxAppHooks.props.value) {
      setApp(wxAppHooks.props.value);
    }
  }, [wxAppHooks.props.value]);

  useEffect(() => {
    Cookies.set(prefix + window.pageProps.uid, 'showed');
    RPCFactory.fansManagement.verifiedList().done((data) => {
      if (_.isArray(data) && data.length > 0) {
        wxAppHooks.setData(data);
        if (currentApp === '') {
          wxAppHooks.setValue(data[0].wxAppId);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (wxAppHooks.props.value !== null) {
      RPCFactory.wechatTagManagement
        .userTagList(wxAppHooks.props.value, {})
        .done((data) => {
          setTagList(data.entities);
        })
        .fail((code, msg) => {
          alert(msg);
        });
    }
  }, [wxAppHooks.props.value]);

  const [ruleListResult, setRuleListResult] = useState({ entities: [], size: 0 });

  const tableHooks = useTable({
    deps: [wxAppHooks.props.value],
    getList: (setTableData, setTotal, curPage, pageSize) => {
      if (wxAppHooks.props.value !== null) {
        return RPCFactory.messageSendingRule
          .list(wxAppHooks.props.value, {})
          .done((data) => {
            setRuleListResult(data);
            setTableData(data.entities);
            setTotal(data.size);
          })
          .fail((status, msg) => {
            alert(msg ? msg : '请求失败');
          });
      }
      return Promise.resolve(null);
    },
  });

  useEffect(() => {
    tableHooks.setTableData(ruleListResult.entities);
    tableHooks.setTotal(ruleListResult.size);
  }, [tagList]);

  const onDelete = (params) => {
    setOperating(true);
    RPCFactory.messageSendingRule
      .delete(wxAppHooks.props.value, deleteConfirmHooks.data.ruleId)
      .done((data) => {
        tableHooks.reloadTable();
        deleteConfirmHooks.setShow(false);
      })
      .fail((code, msg) => {
        props.feedbackHooks.showErrorTip(msg);
      })
      .always(() => {
        setOperating(false);
      });
  };

  const renderTag = (type, name, value, row) => {
    if (type === 'data') {
      if (value === -1) {
        return '全部';
      }
      const index = tagList.findIndex((ele) => ele.tagId === value);

      return index >= 0 ? tagList[index].tagName : value;
    }
    return value;
  };
  const renderNoDisturbTime = (type, name, value, row) => {
    if (type === 'data') {
      const endTime = row.noDisturbEndTime;
      if (value === undefined && endTime === undefined) {
        return '-';
      }
      if (value < endTime) {
        return `${value} - ${endTime}`;
      }
      return `${value} - 次日${endTime}`;
    }
    return value;
  };
  const renderDelaySeconds = (type, name, value, row) => {
    if (type === 'data') {
      const seconds = Math.floor(value % 60);
      const minutes = Math.floor((value / 60) % 60);
      const hours = Math.floor(value / 3600);
      return `${hours}小时${minutes}分${seconds}秒`;
    }
    return value;
  };
  const renderMessageType = (type, name, value, row) => {
    if (type === 'data') {
      return WechatMessageTypeEnum[value] ? WechatMessageTypeEnum[value].desc : value;
    }
    return value;
  };
  const renderRate = (type, name, value, row) => {
    if (type === 'data') {
      if (value === undefined) {
        return '-';
      }
      return `${(value * 100).toFixed(2)}%`;
    }
    return value;
  };
  const renderOp = (type, name, value, row) => {
    if (type === 'data') {
      return (
        <div>
          <div>
            <a
              className="a-link-primary"
              onClick={(e) => {
                setOperating(true);
                RPCFactory.messageSendingRule
                  .get(wxAppHooks.props.value, row.ruleId)
                  .done((data) => {
                    dialogHooks.showAsEditModel(data);
                  })
                  .fail((status, msg) => {
                    alert(msg ? msg : '请求失败');
                  })
                  .always(() => {
                    setOperating(false);
                  });
              }}
            >
              编辑
            </a>
            <a
              className="a-link-primary"
              onClick={(e) => {
                setTarget(e.target);
                deleteConfirmHooks.openDialog(row);
              }}
            >
              删除
            </a>
          </div>
        </div>
      );
    }
    return value;
  };

  return (
    <main className="main" id="main">
      <div className="" style={{ position: 'relative' }}>
        <div className="a-tabs-head-right" style={{ top: '-55px' }}>
          <div className="timely-tips">
            <span style={{ display: 'block', padding: '2px 4px 0 0' }}>所属公众号</span>
            <Select valueFieldName="wxAppId" labelFieldName="nickName" {...wxAppHooks.props} />
          </div>
        </div>
        <div className="card">
          <div id="datarea" className="datarea">
            <div className="toolbars">
              <div className="toolbar table-toolbar">
                <div className="toolbar-left">
                  <Button
                    displayType="primary"
                    onClick={() => {
                      dialogHooks.showAsAddModel();
                    }}
                  >
                    <Icon type="add" />
                    新建消息
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {
            <div className="datalist">
              <Table data={tableHooks.data} loading={tableHooks.tableLoading}>
                <Column name="ruleName">消息名称</Column>
                <Column name="tagId" render={renderTag}>
                  回复对象
                </Column>
                <Column name="noDisturbStartTime" render={renderNoDisturbTime}>
                  免打扰时间
                </Column>
                <Column name="delaySeconds" render={renderDelaySeconds}>
                  发送延迟时间
                </Column>
                <Column name="messageType" render={renderMessageType}>
                  回复内容类型
                </Column>
                <Column name="sendSuccessCount">发送成功消息数</Column>
                <Column name="sendFailCount">发送失败消息数</Column>
                <Column name="clickRate" render={renderRate}>
                  点击率
                </Column>
                <Column name="op" render={renderOp}>
                  操作
                </Column>
              </Table>
            </div>
          }
        </div>
        {dialogHooks.showDialog ? (
          <RuleDialog
            {...dialogHooks}
            tagList={tagList}
            wxAppId={wxAppHooks.props.value}
            onSuccess={() => {
              tableHooks.reloadTable();
              dialogHooks.setShowDialog(false);
            }}
          />
        ) : null}
        <ABulkMiniDialog
          show={deleteConfirmHooks.show}
          onSubmit={onDelete}
          onCancel={deleteConfirmHooks.onClose}
          width={'280px'}
          eventTarget={target}
          eventTargetPlacement={'auto'}
          title={''}
        >
          <div className="confirmbox confirmbox-del">
            <div className="content">
              <p className="tt">确定删除此消息吗？</p>
              <p className="des">消息删除后不可恢复</p>
            </div>
          </div>
        </ABulkMiniDialog>
        <Loading show={operating} type="page" />
      </div>
    </main>
  );
};

export default MessageManagementPage;
